import { Component, OnInit, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'ztsi-bool-picker',
  templateUrl: './ztsi-bool-picker.component.html',
  styleUrls: ['./ztsi-bool-picker.component.css'],
  providers: [
	  {
		  provide: NG_VALUE_ACCESSOR,
		  useExisting: forwardRef(() => ZtsiBoolPickerComponent),
		  multi: true
	  }
  ]
})
export class ZtsiBoolPickerComponent implements ControlValueAccessor {

	@Input('value') _value: boolean;
	@Input() isDisabled: boolean = false;
	@Input() nullLabel = "Yes or No?";
	@Input() trueLabel = "Yes";
	@Input() falseLabel = "No";

	onChange: any = () => { };
	onTouched: any = () => { };

	get value() {
		return this._value;
	}

	set value(val) {
		this._value = val;
		this.onChange(val);
		this.onTouched();
	}

	constructor() { }

	writeValue(value): void {
		if (value !== undefined) {
			this._value = value;
		}
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}
}



// WEBPACK FOOTER //
// ./src/app/components/shared/ztsi-bool-picker/ztsi-bool-picker.component.ts